import { render, staticRenderFns } from "./replay.vue?vue&type=template&id=54022cec"
import script from "./replay.vue?vue&type=script&lang=js"
export * from "./replay.vue?vue&type=script&lang=js"
import style0 from "./replay.vue?vue&type=style&index=0&id=54022cec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports